import Leaflet from 'leaflet';
import React, { useMemo } from 'react';
import ReactDOMServer from 'react-dom/server';
import { Marker } from 'react-leaflet';
import { useDispatch } from 'react-redux';

import { NotFoundIcon } from '../../assets';
import { cancelDraft } from '../../redux/actions';
import { MarkerType } from '../../types';
import MarkerPopup from '../marker-popup';

const MapDraftMarkerComponent = React.memo(({ data }) => {
  const { latlng } = data;
  const dispatch = useDispatch();

  const DOMString = useMemo(
    () =>
      ReactDOMServer.renderToString(
        <div className="is-relative">
          <div className="is-absolute">
            <NotFoundIcon />
          </div>
        </div>
      ),
    []
  );

  return (
    <Marker
      icon={Leaflet.divIcon({
        className: 'leaflet-div-icon',
        html: DOMString,
      })}
      position={latlng}>
      <MarkerPopup
        isDraft
        data={data}
        onClose={() => dispatch(cancelDraft())}
      />
    </Marker>
  );
});

MapDraftMarkerComponent.propTypes = {
  data: MarkerType.isRequired,
};

MapDraftMarkerComponent.displayName = 'MapDraftMarkerComponent';

export default MapDraftMarkerComponent;
